import React, { useEffect, useState } from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import { connect } from "react-redux";
import { getPath } from "../../../utils";
import * as UserActions from "../../../store/actions/User";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import Input from "sushiweb/InputTypes/Input";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import * as ConfigChangeLogActions from "../../../store/actions/Namespace";
import Permission from "../../../components/Common/Permission";
import ErrorMsgs from "../../../constants/Errors.json";
import { bindActionCreators } from "redux";
import variables from "../../../constants/assets/variables";
import PlusCircle from "sushiweb/Icons/all/PlusCircle";
import { FlexContainer } from "../../../constants/assets/containers";
import styled from "styled-components";
import Cross from "sushiweb/Icons/all/Cross";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { isValNull } from "../../../utils";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-monokai";
import {
  getEntities,
  getEntityNames,
  getEntityObjects,
} from "../../../store/actions/FeatureConfig";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import {
  PEAK_TIME_PAYLOAD_PARAM,
  POST_UPDATE_SUB_TYPE_LABELS,
  PRE_UPDATE_SUB_TYPE_LABELS,
  REPEAT_OPTIONS,
  RULE_SUB_TYPES,
} from "../../../constants/FeatureConfig/constants";
import DateTimePicker from "../../Common/DateTimePicker";

const ruleTypeOptions = [
  { key: "pre-update", label: "Prior to config create/update)" },
  { key: "post-update", label: "Post config create/update" },
];

const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
  const activeEle = options.find(
    (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
  );
  return !isValNull(activeEle) ? activeEle[toKey] : "";
};

const AddRuleContainer = styled(FlexContainer)`
  span {
    color: ${variables.black};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
`;

const RuleSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.3rem;
    margin-top: 1.3rem;
    font-size: 5px;
  }
  border-top: 1px solid ${variables.grey200};
`;

const notificationOptions = [{ key: "slack", label: "Slack" }];

const ruleSubTypeOptions = [
  { key: "notification", label: "Notification" },
  { key: "peak-time", label: "Peak Time" },
];

const NamespaceModal = (props) => {
  const {
    activeNamespace,
    handleClose,
    modalState,
    setNamespaces,
    actionsRequired,
  } = props;

  const [initialState, setInitialState] = useState({
    namespace: "",
    configActions: {},
    namespaceActions: {},
    rulesList: [],
  });

  const [isValidJsonSchema, setIsValidJsonSchema] = useState(true);
  const [dropDownModalState, setDropDownModalState] = useState(modalState);

  React.useEffect(() => {
    if (activeNamespace) {
      const values = { ...initialState };
      setInitialState({
        ...activeNamespace,
        rulesList: activeNamespace?.rules || [],
      });
    }
  }, [activeNamespace]);

  const handleNamespaceChange = (key, value) => {
    const values = { ...initialState };
    values[key] = value;
    setInitialState(values);
  };

  const handleAddRule = () => {
    setDropDownModalState("Add");
    const updatedInitialState = {
      ...initialState,
      rulesList: [
        ...initialState.rulesList,
        {
          type: "",
          subType: "",
          id: [],
          baseRule: {},
        },
      ],
    };
    setInitialState(updatedInitialState);
  };
  const handleDeleteRule = (ruleIndex) => {
    const values = { ...initialState };
    const rulesList = getPath(values, "rulesList", []);
    rulesList.splice(ruleIndex, 1);

    setInitialState({
      ...values,
      rulesList: rulesList,
    });
  };

  const handleRuleListChange = (key, val, extraPrams) => {
    let values = { ...initialState };
    const index = extraPrams.length > 0 ? extraPrams[0] : 0;
    if (key == "Source") {
      values.rulesList[index].baseRule["Source"] = val;
    } else if (key == "Schema") {
      if (!values.rulesList[index].baseRule["Meta"]) {
        values.rulesList[index].baseRule["Meta"] = {};
      }
      try {
        JSON.parse(val);
        setIsValidJsonSchema(true);
      } catch (error) {
        setIsValidJsonSchema(false);
      }
      values.rulesList[index].baseRule["Schema"] = val;
    } else if (key === "Channel") {
      if (!values.rulesList[index].baseRule["Meta"]) {
        values.rulesList[index].baseRule["Meta"] = {};
      }
      values.rulesList[index].baseRule["Meta"]["Channel"] = val;
    } else if (key == "id") {
      values.rulesList[index][key] = val;
    } else if (PEAK_TIME_PAYLOAD_PARAM.includes(key)) {
      values.rulesList[index].baseRule[key] = val;
    } else {
      values.rulesList[index][key] = val;
    }
    setInitialState(values);
  };

  const handleSubmit = () => {
    const rules = getPath(initialState, "rulesList", []);
    props
      .upsertNamespace({
        namespace: getPath(initialState, "namespace", ""),
        configActions: getPath(initialState, "configActions", {}),
        namespaceActions: getPath(initialState, "namespaceActions", {}),
        rules: rules.map((rule) => {
          return {
            ...rule,
            entities: getEntityNames(rule.id || []),
          };
        }),
        actionsRequired: actionsRequired,
      })
      .then(() => {
        props.getNamespaces({ limit: 20 }).then((response) => {
          setNamespaces(getPath(response, "namespaces", []));
        });
      })
      .catch((err) => {
        props.setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        });
      });

    handleClose();
  };

  const handleActionChange = (action, actionType, val, index) => {
    let actions = getPath(initialState, action, {});
    actions[actionType][index] = val;
    setInitialState({ ...initialState, action: actions });
  };

  const handleAddAction = (action, type) => {
    let actions = getPath(initialState, action, {});
    (actions[type] = actions[type] ? actions[type] : []).push("");
    setInitialState({ ...initialState, action: actions });
  };

  const handleDeleteAction = (action, type, index) => {
    const values = { ...initialState };
    const actions = getPath(values, action, {});
    actions[type].splice(index, 1);

    setInitialState({
      ...values,
      action: actions,
    });
  };

  const getModalButtons = () => {
    return (
      <BottomSectionModal className="flex items-center justify-between">
        <Button
          data-testid="filterFeatureBtn"
          onClick={handleClose}
          className="sushi-btn"
          btnColor="coal"
        >
          Cancel
        </Button>
        <Permission requiredPerms={[]}>
          <Button
            data-testid="submitFleetCoachButton"
            className="sushi-btn"
            onClick={handleSubmit}
            btnColor="coal"
          >
            Submit
          </Button>
        </Permission>
      </BottomSectionModal>
    );
  };

  return (
    <NoFooterModal
      header={true}
      heading={`${modalState == "edit" ? "Edit" : "Create"} Namespace`}
      handleClose={handleClose}
      id="NamespaceModal"
      modalButtons={getModalButtons()}
    >
      <Input
        value={getPath(initialState, "namespace", "")}
        id="sushi-input"
        label="Namespace"
        onChange={(e) => handleNamespaceChange("namespace", e)}
      />

      {initialState.rulesList.map((rule, index) => {
        return (
          <RuleSection>
            <div className="flex items-center justify-between">
              <p className="sectionHeading">Rule {index + 1}</p>
              <Cross
                size={20}
                showPointer={true}
                onClick={() => handleDeleteRule(index)}
              />
            </div>
            <PaginatedReactDropdown
              options={ruleTypeOptions}
              data-testid={`featureConditionOption${index}`}
              labelKey="label"
              valueKey="key"
              labelWidth="17%"
              value={getInputLabel(
                rule.type,
                ruleTypeOptions,
                "key",
                "label",
                false
              )}
              extraParamsOptionDisable={[index]}
              handleChange={handleRuleListChange}
              keyToChange="type"
              extraParams={[index]}
              placeholder="Rule Type"
              showCross={false}
              id={`featureConditionOption${index}`}
            />
            <PaginatedReactDropdown
              options={ruleSubTypeOptions}
              data-testid={`featureComparatorOption${index}`}
              labelKey="label"
              valueKey="key"
              labelWidth="14%"
              value={getInputLabel(
                rule.subType,
                ruleSubTypeOptions,
                "key",
                "label",
                false
              )}
              handleChange={handleRuleListChange}
              keyToChange="subType"
              extraParams={[index]}
              isOptionDisabled={(option) => {
                switch (initialState.rulesList[index].type) {
                  case "pre-update":
                    return POST_UPDATE_SUB_TYPE_LABELS.includes(option);
                  case "post-update":
                    return PRE_UPDATE_SUB_TYPE_LABELS.includes(option);
                  default:
                    return false;
                }
              }}
              placeholder="Sub Type"
              showCross={false}
              id={`featureComparatorOption${index}`}
            />

            <InfiniteScrollDropdown
              id={`entitiesDropdown${index}`}
              priorityFlag={true}
              activeElement={rule.activeEntity}
              getActiveList={getEntities}
              resKey="entities"
              modalState={
                dropDownModalState?.charAt(0)?.toUpperCase() +
                dropDownModalState?.slice(1)
              }
              keyName="id"
              labelKey="name"
              getDataLabelKey="entities.name"
              keyTypeToSet="id"
              label="Entities"
              handleChange={handleRuleListChange}
              extraParams={[index]}
              getActiveItemById={getEntityObjects}
              multiple
            />

            {rule.subType == RULE_SUB_TYPES.PEAK_TIME && (
              <div style={{ marginTop: "30px" }}>
                <DateTimePicker
                  value={rule.baseRule?.StartTime}
                  placeholder="Start Time"
                  handleChange={(e) =>
                    handleRuleListChange("StartTime", e.target.value, [index])
                  }
                  id="start_time"
                />
                <DateTimePicker
                  value={rule.baseRule?.EndTime}
                  placeholder="End Time"
                  handleChange={(e) =>
                    handleRuleListChange("EndTime", e.target.value, [index])
                  }
                  id="end_time"
                />

                <PaginatedReactDropdown
                  options={REPEAT_OPTIONS}
                  data-testid={`repeatOptions${index}`}
                  labelKey="label"
                  valueKey="key"
                  labelWidth="17%"
                  value={getInputLabel(
                    rule.baseRule.Repeat,
                    REPEAT_OPTIONS,
                    "key",
                    "label",
                    false
                  )}
                  extraParamsOptionDisable={[index]}
                  handleChange={handleRuleListChange}
                  keyToChange="Repeat"
                  extraParams={[index]}
                  placeholder="Repeat"
                  showCross={false}
                  id={`repeatOptions${index}`}
                />
              </div>
            )}

            {rule.subType == RULE_SUB_TYPES.NOTIFICATION && (
              <div>
                <p className="sectionHeading">Rule Configuration</p>
                <PaginatedReactDropdown
                  options={notificationOptions}
                  data-testid={`featureConditionOption${index}`}
                  labelKey="label"
                  valueKey="key"
                  labelWidth="17%"
                  value={getInputLabel(
                    rule.baseRule.Source,
                    notificationOptions,
                    "key",
                    "label",
                    false
                  )}
                  extraParamsOptionDisable={[index]}
                  handleChange={handleRuleListChange}
                  keyToChange="Source"
                  extraParams={[index]}
                  placeholder="Source"
                  showCross={false}
                  id={`featureConditionOption${index}`}
                />

                <p style={{ marginBottom: "20px" }}>
                  Provide slack channel name where you want config updates to be
                  delivered. You can specify slack channel on key/namespace
                  level. Please make sure #config-update-alert bot is added into
                  that channel.
                </p>

                <Input
                  value={rule.baseRule?.Meta?.Channel}
                  data-testid={`featureConditionValue${index}`}
                  id="sushi-input"
                  onChange={(e) => handleRuleListChange("Channel", e, [index])}
                  label={"Channel Name"}
                />
              </div>
            )}

            {rule.subType == RULE_SUB_TYPES.VALIDATION && (
              <div>
                <p className="sectionHeading">Rule Configuration</p>
                <p style={{ marginBottom: "20px" }}>
                  Schema should be defined on global configuration. This ensures
                  properties are created as expected. Please refer to JSON
                  Schema draft for how to write validation schema. Supports
                  draft-04, draft-06, and draft-07. References:
                </p>
                <ul style={{ marginBottom: "20px" }}>
                  <li>
                    <a
                      href="https://json-schema.org/learn/getting-started-step-by-step"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://json-schema.org/learn/getting-started-step-by-step
                    </a>
                  </li>
                </ul>

                <AceEditor
                  mode="json"
                  theme="monokai"
                  label={"Validation Schema"}
                  value={rule.baseRule?.Schema}
                  onChange={(e) => handleRuleListChange("Schema", e, [index])}
                  name="json-editor"
                  editorProps={{ $blockScrolling: true }}
                  style={{
                    width: "100%",
                    height: "300px",
                    marginBottom: "20px",
                  }}
                />
                {!isValidJsonSchema && (
                  <p style={{ color: "red" }}>Invalid JSON Schema</p>
                )}
              </div>
            )}
          </RuleSection>
        );
      })}

      <AddRuleContainer>
        <div
          className="flex delete-icon"
          onClick={() => {
            handleAddRule();
          }}
        >
          <PlusCircle color={variables.black} size={20} />
          <span>
            Add {initialState.rulesList.length ? "another" : ""} Rule (e.g.
            config validation / notification etc)
          </span>
        </div>
      </AddRuleContainer>

      {getPath(initialState, "namespaceActions.read", []).map(
        (readAction, index) => {
          return (
            <ActionSection>
              <div className="flex items-center justify-between">
                <p className="sectionHeading">
                  Namespace Read Action {index + 1}
                </p>
                <Cross
                  size={20}
                  showPointer={true}
                  onClick={() =>
                    handleDeleteAction("namespaceActions", "read", index)
                  }
                />
              </div>
              <Input
                value={readAction}
                data-testid="read-action"
                id="sushi-input"
                label="read Action"
                onChange={(e) =>
                  handleActionChange("namespaceActions", "read", e, index)
                }
              />
            </ActionSection>
          );
        }
      )}
      <AddActionContainer>
        <div
          className="flex delete-icon"
          onClick={() => {
            handleAddAction("namespaceActions", "read");
          }}
        >
          <PlusCircle color={variables.black} size={20} />
          <span>
            Add
            {getPath(initialState, "namespaceActions.read", []).length
              ? " Another "
              : " "}
            Namespace Read Action
          </span>
        </div>
      </AddActionContainer>

      {getPath(initialState, "namespaceActions.write", []).map(
        (writeAction, index) => {
          return (
            <ActionSection>
              <div className="flex items-center justify-between">
                <p className="sectionHeading">
                  Namespace Write Action {index + 1}
                </p>
                <Cross
                  size={20}
                  showPointer={true}
                  onClick={() =>
                    handleDeleteAction("namespaceActions", "write", index)
                  }
                />
              </div>
              <Input
                value={writeAction}
                data-testid="write-action"
                id="sushi-input"
                label="write Action"
                onChange={(e) =>
                  handleActionChange("namespaceActions", "write", e, index)
                }
              />
            </ActionSection>
          );
        }
      )}
      <AddActionContainer>
        <div
          className="flex delete-icon"
          onClick={() => {
            handleAddAction("namespaceActions", "write");
          }}
        >
          <PlusCircle color={variables.black} size={20} />
          <span>
            Add
            {getPath(initialState, "namespaceActions.write", []).length
              ? " Another "
              : " "}
            Namespace Write Action
          </span>
        </div>
      </AddActionContainer>

      {getPath(initialState, "configActions.read", []).map(
        (readAction, index) => {
          return (
            <ActionSection>
              <div className="flex items-center justify-between">
                <p className="sectionHeading">Config Read Action {index + 1}</p>
                <Cross
                  size={20}
                  showPointer={true}
                  onClick={() =>
                    handleDeleteAction("configActions", "read", index)
                  }
                />
              </div>
              <Input
                value={readAction}
                data-testid="read-action"
                id="sushi-input"
                label="read Action"
                onChange={(e) =>
                  handleActionChange("configActions", "read", e, index)
                }
              />
            </ActionSection>
          );
        }
      )}
      <AddActionContainer>
        <div
          className="flex delete-icon"
          onClick={() => {
            handleAddAction("configActions", "read");
          }}
        >
          <PlusCircle color={variables.black} size={20} />
          <span>
            Add
            {getPath(initialState, "configActions.read", []).length
              ? " Another "
              : " "}
            Config Read Action
          </span>
        </div>
      </AddActionContainer>

      {getPath(initialState, "configActions.write", []).map(
        (writeAction, index) => {
          return (
            <ActionSection>
              <div className="flex items-center justify-between">
                <p className="sectionHeading">
                  Config Write Action {index + 1}
                </p>
                <Cross
                  size={20}
                  showPointer={true}
                  onClick={() =>
                    handleDeleteAction("configActions", "write", index)
                  }
                />
              </div>
              <Input
                value={writeAction}
                data-testid="write-action"
                id="sushi-input"
                label="write Action"
                onChange={(e) =>
                  handleActionChange("configActions", "write", e, index)
                }
              />
            </ActionSection>
          );
        }
      )}
      <AddActionContainer>
        <div
          className="flex delete-icon"
          onClick={() => {
            handleAddAction("configActions", "write");
          }}
        >
          <PlusCircle color={variables.black} size={20} />
          <span>
            Add
            {getPath(initialState, "configActions.write", []).length
              ? " Another "
              : " "}
            Config Write Action
          </span>
        </div>
      </AddActionContainer>
    </NoFooterModal>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getNamespaces: bindActionCreators(
      ConfigChangeLogActions.getNamespaces,
      dispatch
    ),
    upsertNamespace: bindActionCreators(
      ConfigChangeLogActions.upsertNamespace,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(NamespaceModal);

const ActionSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.3rem;
    margin-top: 1.3rem;
    font-size: 5px;
  }
  border-top: 1px solid ${variables.grey200};
`;

const AddActionContainer = styled(FlexContainer)`
  span {
    color: ${variables.black};
    font-weight: 500;
    margin-left: 5px;
  }
  margin: 0 1.5rem 1.5rem 0;
`;
